enum OrganizationQuestionLocation {
  ORGANIZATION = 'ORG',
  CONTACT = 'CNT',
  TERMS = 'TRM',
}

export default OrganizationQuestionLocation;
